import {createSelector} from '@reduxjs/toolkit';
import {TStateStore} from 'store';

const getPermissions = (state: TStateStore) => state.permissions;

export const permissionsStateSelector = createSelector(getPermissions, (permissions) => permissions);
export const userRoleListStateSelector = createSelector(getPermissions, (permissions) => permissions.roleList);
export const exportingSelector = createSelector(getPermissions, (permissions) => permissions.exporting);
